export default "<div class=\"container\">\n\t<div class=\"aboutus_text\">\n<div id=\"html\" class=\"footerdesc\" style=\"color:#fff;\" ></div>\n</div>\n</div>"